import { filesToObject } from 'src/utils';

export const inputFilesChange = (e, callback) => {
  if (e && e.target && e.target.files) {
    let _files = Array.from(e.target.files);
    filesToObject(_files).then((res) => {
      callback(res);
    });
  }
};
